








































































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import WidgetWrapper from '@/components/widgets/WidgetWrapper.vue';
import UploadCreatives from '@/components/campaign/UploadCreatives.vue';
import UploadFromPCCreatives from '@/components/campaign/UploadFromPCCreatives.vue';
import EditCreatives from '@/components/campaign/EditCreatives.vue';
import SelectCreatives from '@/components/campaign/SelectCreatives.vue';
import SelectImages from '@/components/campaign/SelectImages.vue';
import { Creative, PaginationData } from '@/types';
import TheCreatives from '@/components/campaign/creatives/TheCreatives.vue';
import { ICreative } from '@/types/campaign/creatives';
import Preloader from '@/components/preloader/Preloader.vue';
import { getIcon, TIconSvg } from '@/configs/iconsConfigs';
import CreativeService from '@/services/CreativeService';
import { getTranslate } from '@/helpers/translateHelpers';
import {
  CREATIVE_FIELDS,
  MODERATION_EXPAND,
  MODERATION_FIELDS,
} from '@/configs/creativeConfigs';

export default Vue.extend({
  name: 'TheCreativesForm',
  components: {
    WidgetWrapper,
    UploadCreatives,
    UploadFromPCCreatives,
    EditCreatives,
    SelectCreatives,
    SelectImages,
    TheCreatives,
    Preloader,
  },

  props: {
    campaignId: {
      type: [String, Number],
      required: true,
      default: null,
    },
    ssp: {
      type: Array,
      required: false,
      default: () => [],
    },
    isActivated: {
      type: Boolean,
      default: false,
    },
    loadData: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  mounted() {
    if (!this.allCreatives?.allIds?.length) {
      this.requests();
    }
  },

  watch: {
    campaignId() {
      this.requests();
    },
    isActivated() {
      this.requests();
    },
  },

  computed: {
    ...mapGetters({
      allCreatives: 'campaignCreatives/getAllCreatives',
      otherCreatives: 'campaignCreatives/getOtherCreatives',
    }),
    otherCreativesData(): Array<Creative> {
      return this.otherCreatives.data;
    },
    otherCreativesPagination(): PaginationData {
      return this.otherCreatives.paginationData;
    },
    imagesData(): Array<Creative> {
      return this.$store.state.campaign.images.data;
    },
    imagesPagination(): PaginationData {
      return this.$store.state.campaign.images.paginationData;
    },
  },

  methods: {
    getIcon(iconName: string): TIconSvg {
      return getIcon(iconName);
    },
    getTranslate(path: string): string {
      return getTranslate(path);
    },
    async requests() {
      if (this.isActivated && this.campaignId) {
        const campaign_id = this.campaignId;
        await Promise.all([
          this.$store.dispatch('loadCreativeStatistics', {
            searchData: {
              campaign_id,
            },
            columns: CREATIVE_FIELDS,
          }),
          this.$store.dispatch('campaignCreatives/loadModerateCreatives', {
            searchData: {
              campaign_id,
            },
            fields: MODERATION_FIELDS,
            expand: MODERATION_EXPAND,
          }),
        ]);
      }
    },
    async selectCreatives(data) {
      this.isOpenCreatives = true;
      this.loadCreatives = true;
      await this.$store.dispatch('campaignCreatives/loadOtherCreatives', {
        ...data,
        sort: this.sortCreatives,
      });
      this.loadCreatives = false;
    },
    async getImages(data, resolve) {
      this.isOpenImages = true;
      this.loadCreatives = true;
      await this.$store.dispatch('getImages', {
        ...data,
        sort: this.sortCreatives,
      });
      if (resolve) {
        resolve('resolve');
      }
      this.loadCreatives = false;
    },
    async getCreatives(data, resolve) {
      this.loadCreatives = true;
      await this.$store.dispatch('campaignCreatives/loadOtherCreatives', data);
      if (resolve) {
        resolve('resolve');
      }
      this.loadCreatives = false;
    },
    addCreatives(creatives: Array<Creative>) {
      CreativeService.addCreatives(creatives);
    },
    uploadCreatives(creatives: Array<ICreative>) {
      CreativeService.uploadNewCreatives(creatives);
    },
  },

  data() {
    return {
      isOpenCreatives: false,
      isOpenImages: false,
      loadCreatives: false,
      sortCreatives: '-created_ts',
    };
  },
});
